import React from 'react';

const CircleIcon = ({ size = 10, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width={size}
    height={size}
    viewBox="0 0 48 48"
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <path d="M24 40c-8.822 0-16-7.178-16-16S15.178 8 24 8s16 7.178 16 16-7.178 16-16 16z" />
    </g>
  </svg>
);

export default CircleIcon;
